"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = TreeChildren;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _child = _interopRequireDefault(require("./child"));

function TreeChildren(_ref) {
  var data = _ref.data,
      onSelect = _ref.onSelect,
      onExpandCollapse = _ref.onExpandCollapse,
      nodePath = _ref.nodePath;
  return data.map(function (props, index) {
    return _react["default"].createElement(_child["default"], (0, _extends2["default"])({}, props, {
      onSelect: onSelect,
      onExpandCollapse: onExpandCollapse,
      nodePath: [].concat((0, _toConsumableArray2["default"])(nodePath), [index])
    }));
  });
}